import { useState } from "react";
import Bullet from "./common/Bullet";
import { splitBullets } from "../lib/utils";

function IdeaContent({ idea }) {
  return (
    <div>
      <div className="text-body font-bold text-text-primary leading-snug mb-2">{idea.title}</div>
      {idea.missing && (
        <div className="mb-2">
          <span className="text-meta font-bold tracking-wide uppercase block mb-1 text-text-tertiary">보도 공백</span>
          <Bullet text={idea.missing} className="text-sub text-text-secondary leading-relaxed" />
        </div>
      )}
      <div className="flex flex-col gap-2.5">
        {idea.reasoning && (
          <div>
            <span className="text-meta font-bold tracking-wide uppercase block mb-1 text-text-tertiary">판단 근거</span>
            {splitBullets(idea.reasoning).map((s, j) => <Bullet key={j} text={s} className="text-sub text-text-secondary leading-relaxed" />)}
          </div>
        )}
        {idea.proposal && (
          <div>
            <span className="text-meta font-bold tracking-wide uppercase block mb-1 text-text-tertiary">취재 제안</span>
            {splitBullets(idea.proposal).map((s, j) => <Bullet key={j} text={s} className="text-sub text-text-secondary leading-relaxed" />)}
          </div>
        )}
        {idea.actions?.length > 0 && (
          <div>
            <span className="text-meta font-bold tracking-wide uppercase block mb-1 text-text-tertiary">취재 행동</span>
            {idea.actions.map((a, j) => <Bullet key={j} text={a} className="text-sub text-text-secondary leading-relaxed" />)}
          </div>
        )}
      </div>
    </div>
  );
}

export default function IdeaCard({ idea, onMore }) {
  const [moreIdeas, setMoreIdeas] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleMore = async () => {
    if (!onMore || loading) return;
    setLoading(true);
    try {
      const results = await onMore(idea);
      setMoreIdeas(prev => [...prev, ...results]);
    } catch {}
    setLoading(false);
  };

  return (
    <div className="border-b border-border-line animate-fadeUp">
      <div className="p-4">
        <IdeaContent idea={idea} />

        {/* More 버튼 */}
        {onMore && (
          <div className="mt-3 text-center">
            {loading ? (
              <span className="text-meta text-text-tertiary">생성 중…</span>
            ) : (
              <button
                onClick={handleMore}
                className="bg-transparent border-none text-text-tertiary text-meta tracking-widest uppercase cursor-pointer py-1 px-0"
              >
                More →
              </button>
            )}
          </div>
        )}
      </div>

      {/* 관련 아이디어 */}
      {moreIdeas.length > 0 && (
        <div className="border-t border-border-line bg-bg-secondary">
          {moreIdeas.map((m, i) => (
            <div key={i} className="px-4 pt-4 pb-4 border-b border-border-line last:border-b-0">
              <div className="flex items-start gap-2 mb-2">
                <span className="text-meta text-text-tertiary mt-[2px] flex-shrink-0">↳</span>
                <IdeaContent idea={m} />
              </div>
            </div>
          ))}
          {/* More 추가 로드 */}
          <div className="px-4 py-3 text-center">
            {loading ? (
              <span className="text-meta text-text-tertiary">생성 중…</span>
            ) : (
              <button
                onClick={handleMore}
                className="bg-transparent border-none text-text-tertiary text-meta tracking-widest uppercase cursor-pointer py-1 px-0"
              >
                More →
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
